import React from "react";
import { useParams } from "react-router";

import TestClaimLayout from "@/App/layouts/TestClaim";
import FileDownload from "./FileDownload";

interface UrlParams {
  id?: string;
}

const ViewBatchClaims: React.FC = () => {
  const { id }: UrlParams = useParams();

  return (
    <TestClaimLayout selected="rightToggle">
      <FileDownload fileID={id} />
    </TestClaimLayout>
  );
};

export default ViewBatchClaims;
